<template>
	<div >
		
		<div class="ft20 cl-black cl-main ftw500">我的伙伴</div>
		
		<div class="mt20">
			<div class="bg-w pd30" style="min-height: 600px;">
				
				<div class="">
					<div class=" ">
						<a-form layout="inline">
							<a-form-item label="邀请人">
								<a-input v-model="search.keyword" placeholder="请输入邀请人信息"></a-input>
							</a-form-item>
							
							<a-form-item>
								<a-button @click="searchAct" type="primary">查询</a-button>
								<a-button @click="cancelAct" class="ml10">取消</a-button>
							</a-form-item>
						</a-form>
					</div>
				</div>
				
				<!-- <div class="mt20">
					<a-radio-group v-model="search.status" button-style="solid" @change="changeStatus">
						 
						<a-radio-button :value="0">
							<div class="flex" style="position: relative;">待审核
								<div class="tag-num positon" v-if="to_do_num>0">{{to_do_num}}</div>
							</div>
						</a-radio-button>
						<a-radio-button :value="1">
						  历史记录
						</a-radio-button>
					</a-radio-group>
				</div> -->

				<div class="mt30">
					<div class="wxb-table-gray">
						<a-table rowKey="withdraw_id" :columns="columns" :pagination="pagination" @change="handleTableChange" :data-source="datas"
						 :loading="loading">
							
							<div class="flex alcenter center withdraw-member" slot="rmember" slot-scope="rmember,record">
								<img v-if="record.face != null" :src="record.face"/>
								<img v-else src="../../assets/image/woyaoyou_head_defult@2x.png"/>
								<div class="ml10">{{record.nick_name}}｜{{record.mobile}}</div>
							</div>
							
							<div class="flex alcenter center withdraw-member" slot="pmember" slot-scope="pmember,record">
								<img v-if="pmember.face != null" :src="pmember.face"/>
								<img v-else src="../../assets/image/woyaoyou_head_defult@2x.png"/>
								<div class="ml10">{{pmember.nick_name}}｜{{pmember.mobile}}</div>
							</div>
							
							<!-- <template slot="action" slot-scope="record">
								<div class="flex center" v-if="record.status==0">
									<a-button type="primary" ghost @click="agreeAct(record)">同意</a-button>
								</div>
								<div class="flex center" v-if="record.status!=0">
									-
								</div>
							</template> -->
						</a-table>
					</div>
				</div>
			
			</div>
		</div>
	</div>
				
</template>

<script>
	import {
		listMixin
	} from '../../common/mixin/list.js';
	export default {
		mixins: [listMixin],
		data() {
			return {
				loading: false,
				pagination: {
					current: 1,
					pageSize: 10, //每页中显示10条数据
					total: 0,
				},
				search: {
					keyword:'',
					status:0,
				},
				to_do_num:0,
				columns: [
					{title: '被邀请人',dataIndex: 'nick_name',align: 'center',scopedSlots: {customRender: 'rmember'}},
					{title: '邀请人',dataIndex: 'pmember',align: 'center',scopedSlots: {customRender: 'pmember'}},
					{title: '状态',dataIndex: 'status_means',align: 'center',ellipsis: true},
					{title: '时间',dataIndex: 'add_time_format',align: 'center',ellipsis: true},
					// {title: '操作',key: 'action',align: 'center',scopedSlots: {customRender: 'action'}},
				],
				datas: [],
			}
		},
		methods: {
			
			getLists(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/commission/myMemberList',{
					keyword:this.search.keyword,
					limit:this.pagination.pageSize,
					page:this.pagination.current
				}).then(res=>{
					this.pagination.total=res.total;
					this.datas=res.list;
					this.to_do_num=res.to_do_num;
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
				})
			},
			
			searchAct(){
				this.pagination.current=1;
				this.getLists();
			},

			cancelAct(){
				this.search.keyword = '';
				this.pagination.current=1;
				this.getLists();
			},
			
			changeStatus(){
				this.pagination.current=1;
				this.getLists();
			},
			
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current;
				this.getLists();
			},
			
		}
	}
</script>

<style>
	.withdraw-member img{
		width: 40px;
		height: 40px;
		border-radius: 20px;
	}
	
	.tag-num{
		background: #FF6600;
		border-radius: 8px;
		padding: 0 5px;
		font-size: 12px;
		font-weight: 400;
		color: #FFFFFF;
		height: 16px;
		line-height: 16px;
	}
</style>
